export const initializeHubSpot = () => {
    const isProduction = process.env.VUE_ADM_PAGE === 'https://adm.voompcreators.com.br';

    if (!isProduction) {
        return;
    }

    if (document.getElementById('hs-script-loader')) {
        return;
    }

    const hubspotScript = document.createElement('script');
    hubspotScript.type = 'text/javascript';
    hubspotScript.id = 'hs-script-loader';
    hubspotScript.async = true;
    hubspotScript.defer = true;
    hubspotScript.src = '//js.hs-scripts.com/48572757.js';
    
    hubspotScript.onload = () => {
        console.log('HubSpot carregado com sucesso.');
    };
    
    hubspotScript.onerror = (error) => {
        console.error('Erro ao carregar o script do HubSpot:', error);
    };
    
    document.head.appendChild(hubspotScript);
}; 